module.exports = __webpack_public_path__ + "static/media/icon-open-sell-big.f913f6d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-open-sell-big.svg
// module id = 1233
// module chunks = 19